<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-col pb-1 class="pa-0">
    <v-flex my-2>
      <SimpleCard >
        <v-row
          xs12
          md12
          xl12
          lg12
        >
          <v-flex>
            <v-layout>
              <v-flex
                v-if="summary"
                xl2
                md2
                lg2
              >
                <v-card-actions
                  px-0
                  py-0
                >
                  <v-list-item class="py-0 my-0 px-0 min-height-list-item">
                    <v-list-item-content class="py-0 my-0">
                      <v-list-item-title class="cmr-label-text">
                        Total Active
                      </v-list-item-title>
                      <v-list-item-subtitle class="cmr-value-text">
                        {{ summary.totalActive }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="py-0 my-0 px-0 min-height-list-item">
                    <v-list-item-content class="py-0 my-0">
                      <v-list-item-title class="cmr-label-text">
                        Total Cancelled
                      </v-list-item-title>
                      <v-list-item-subtitle class="cmr-value-text">
                        {{ summary.totalCancelled }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-actions>
              </v-flex>
              <v-flex
                xl10
                md10
                lg10
              >
                <RepeatServiceSearchBoxV2
                  class="mb-2"
                  :query="query"
                  @search="search"
                  @changeQuery="getRepeatServices"
                  @createRepeatService="createRepeatService"
                  @clear="clear"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-row>
      </SimpleCard>
    </v-flex>
    <v-flex>
         <v-flex v-if="loading" xs12 pa-1 class="text-xs-center">
            <v-progress-circular
              :size="48"
              :width="5"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-flex>
          <RepeatServiceList
            v-if="!loading"
            :repeatServices="repeatServices"
            :paginationProp="pagination"
            @edit="showEdit"
          ></RepeatServiceList>
          <v-flex v-if="!loading" pt-2 md12 class="text-center pt-2 justify-center">
            <v-pagination
              @input="changePage"
              v-model="pagination.page"
              :length="num_pages"
            ></v-pagination>
          </v-flex>
    </v-flex>
    <template>
      <v-dialog persistent v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Create Repeat Service</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-flex xs12>
                  <v-text-field
                    v-model="serviceName"
                    label="Service Name*"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="customer"
                    :items="customerList"
                    :loading="loading"
                    :search-input.sync="searchAttr"
                    item-text="name"
                    label="Customer Search*"
                    hide-no-data
                    hide-selected
                    no-filter
                    return-object
                    @change="customerSelected"
                    required
                  ></v-autocomplete>
                </v-flex>
              </v-row>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-flex grow></v-flex>
            <v-btn class="text-none light" flat text @click="dialog = false"
              >Cancel</v-btn
            >
            <v-btn
              :disabled="
                !(
                  serviceName.length > 0 &&
                  customer.id != undefined &&
                  customer.id != null
                )
              "
              class="text-none light"
              color="blue lighten-1"
              text
              @click="create()"
              >Create</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="editDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Repeat Service</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-flex xs12>
                  <v-text-field
                    v-model="editService.name"
                    label="Service Name*"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    v-model="editService.cancelled"
                    label="Hide"
                    required
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="customerEdit"
                    :items="customerListEdit"
                    :loading="loading"
                    :search-input.sync="searchEdit"
                    item-text="name"
                    label="Customer Search*"
                    hide-no-data
                    hide-selected
                    no-filter
                    return-object
                    @change="customerSelectedEdit"
                    required
                  ></v-autocomplete>
                </v-flex>
              </v-row>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-flex grow></v-flex>
            <v-btn class="text-none light" flat text @click="editDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              :disabled="
                !(
                  editService.name.length > 0 &&
                  editService.user.id != undefined &&
                  editService.user.id != null
                )
              "
              class="text-none light"
              color="blue lighten-1"
              text
              @click="edit()"
              >Update</v-btn
            >
            <v-btn
              class="text-none light"
              flat
              color="orange"
              @click="goToRepeatService(editService.id)"
              >Edit Repeat Service Trips</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-col>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import RepeatServiceList from "@/components/repeat_service/RepeatServiceListV2.vue";
import RepeatServiceSearchBox from "@/components/repeat_service/RepeatServiceSearchBox.vue";

import qs from "qs";
import axios from "axios";
import RepeatServiceSearchBoxV2 from '@/components/repeat_service/RepeatServiceSearchBoxV2'
axios.defaults.withCredentials = true;

export default {
  name: "repeat_service",
  components: {
    RepeatServiceSearchBoxV2,
    SimpleCard,
    RepeatServiceList,
    RepeatServiceSearchBox,
  },
  data: function () {
    return {
      editService: {
        name: "",
        user: {
          name: "",
        },
      },
      serviceName: "",
      dialog: false,
      repeatServices: [],
      offset: 0,
      count: 20,
      query: {
        includeCancelled: false,
        query: "",
        noDriver: false
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      searchAttr: null,
      searchEdit: null,
      customers: [],
      customer: {},
      customersEdit: [],
      customerEdit: {},
      editDialog: false,
    };
  },
  computed: {
    summary () {
      return this.$store.getters['repeatService/getSummary']
    },
    customerList: function () {
      return this.customers;
    },
    customerListEdit: function () {
      return this.customersEdit;
    },
  },
  watch: {
    searchAttr(val) {
      console.log(val);

      if (val == null) return;
      if (val.length <= 1) return;

      var url = `${this.$store.state.apiUrl}/customer/search?query=${val}`;

      var searchCompleted = this.searchCompleted;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          searchCompleted(res.data);
        })
        .catch(function (err) {
          console.error(err);
          this.loading = false;
        });
    },
    searchEdit(val) {
      console.log(val);

      if (val == null) return;
      if (val.length <= 1) return;

      var url = `${this.$store.state.apiUrl}/customer/search?query=${val}`;

      var searchCompletedEdit = this.searchCompletedEdit;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          searchCompletedEdit(res.data);
        })
        .catch(function (err) {
          console.error(err);
          this.loading = false;
        });
    },
  },
  mounted: async function () {
    this.getRepeatServices();
    this.$store.dispatch('repeatService/getSummary')
  },
  methods: {
    goToRepeatService: function (id) {
      this.$router.push("/repeat_service/edit/" + id);
    },
    showEdit: function (rs) {
      console.log("Showing edit for " + rs.name);
      this.editService = rs;
      this.editDialog = true;

      this.customersEdit = [rs.user];
      this.customerEdit = rs.user;
      // this.searchEdit = "";
    },
    create: async function () {
      this.dialog = false;

      try {
        let response = await axios.post(
          `${
            this.$store.state.apiUrl
          }/repeat_service/create?name=${encodeURIComponent(
            this.serviceName
          )}&user_id=${this.customer.id}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        if (response.data.error == "no_error") {
          this.$router.push(
            "/repeat_service/edit/" + response.data.repeat_service.id
          );
        } else {
          alert(response.data.error);
        }
      } catch (error) {
        console.log(error);
        alert("Unknown error");
      }
    },
    edit: async function () {
      this.editDialog = false;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/repeat_service/${this.editService.id}/update?name=${this.editService.name}&hide=${this.editService.cancelled}&user_id=${this.customerEdit.id}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        if (response.data.error == "no_error") {
          alert("Service updated");
          this.getRepeatServices();
        } else {
          alert(response.data.error);
        }
      } catch (error) {
        console.log(error);
        alert("Unknown error");
      }
    },
    searchCompleted: function (data) {
      this.customers = data.customers;

      this.loading = false;
    },
    searchCompletedEdit: function (data) {
      this.customersEdit = data.customers;

      this.loading = false;
    },
    customerSelected: function (customer) {
      console.log("Changed " + JSON.stringify(customer));
    },
    customerSelectedEdit: function (customer) {
      console.log("Changed " + JSON.stringify(customer));
    },
    createRepeatService: function () {
      console.log("Creating repeat service");
      this.dialog = true;
    },
    search: function () {
      this.pagination.page = 1;
      this.getRepeatServices();
    },
    clear: function () {
      this.query = {
        includeCancelled: "all",
      };
    },
    changePage: function (page) {
      this.pagination.page = page;
      console.log(page);
      this.getRepeatServices();
    },
    getRepeatServices: async function () {
      this.loading = true;
      if (!this.query.query) {
        this.query.query = ""
      }

      try {
        var url = `${this.$store.state.apiUrl}/repeat_service/all2?offset=${
          this.count * (this.pagination.page - 1)
        }&count=${this.count}&include_cancelled=${this.query.includeCancelled}&query=${this.query.query}&no_driver_assigned=${this.query.noDriver}`;

        let response = await axios.get(url, {
          params: {},
        });

        var repeatServices = response.data.repeat_services;

        this.repeatServices = repeatServices;
        this.num_pages = response.data.num_pages;

        console.log(response.data.num_pages);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get repeat services " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>
